import { Button } from '@material-ui/core'
import { HourglassEmpty } from '@material-ui/icons'
import customCircleCheck from '../../../assets/img/icons/ic-check-circle.png'
import { useDateFormatter } from '../../../hooks/useDateFormatter'
import SingleFileDisplay from '../../Form/SingleFileDisplay'
import ModalPopUp from '../../ModalPopUp/ModalPopUp'

interface Props {
  showRevisionsModal: boolean
  setShowRevisionsModal: (val: boolean) => void
  project: Project
}

interface RevisionProps {
  file: AcceptanceCriteria
}
const Revision = ({ file }: RevisionProps) => {
  const updatedAt = useDateFormatter(file.updatedAt)

  return (
    <div className="align-center flex gray-text space-between align-center m-b-16">
      <div className="flex flex-grow">
        <div className="fs14 m-r-24">{updatedAt}</div>
        <SingleFileDisplay file={file} />
      </div>
      <div className="fs14 flex m-l-24 m-b-8">
        {file.isSigned ? (
          <div className="paid">
            <img
              src={customCircleCheck}
              alt="Circle Check"
              style={{ width: 14 }}
            />{' '}
            Signed
          </div>
        ) : (
          <>
            <HourglassEmpty style={{ width: 14 }} />
            Pending signature
          </>
        )}
      </div>
    </div>
  )
}

const RevisionsModal = ({
  showRevisionsModal,
  setShowRevisionsModal,
  project,
}: Props) => {
  return (
    <ModalPopUp
      title="Service agreement revisions"
      setShowModal={setShowRevisionsModal}
      showModal={showRevisionsModal}
      variant="medium"
    >
      <h4 className="m-b-24">Previous revisions</h4>
      {project.acceptanceCriteria &&
        project.acceptanceCriteria.length > 1 &&
        project.acceptanceCriteria.map(
          (file: AcceptanceCriteria, index: number) => (
            <Revision key={index} file={file} />
          )
        )}

      <div className="flex flex-end">
        <Button
          className="m-t-40"
          variant="outlined"
          color="primary"
          onClick={() => setShowRevisionsModal(false)}
        >
          Done
        </Button>
      </div>
    </ModalPopUp>
  )
}

export default RevisionsModal
